import React from 'react';

import { DateInput, DateInputProps } from '@mantine/dates';

import dateInputClasses from './kiloDateInput.module.css';

interface KiloDateInputProps extends DateInputProps {
  variantStyle?: 'default' | 'kiosk'; // extend as needed
  label?: string;
}

const variantClassMap = {
  default: {},
  kiosk: {
    input: dateInputClasses.kiosk,
    label: dateInputClasses.kioskLabel,
  },
};

const KiloDateInput = ({ variantStyle = 'default', label, ...props }: KiloDateInputProps): JSX.Element => {
  const variantClasses = variantClassMap[variantStyle];

  return (
    <DateInput
      label={label}
      classNames={{
        ...variantClasses,
      }}
      {...props}
    />
  );
};

export default KiloDateInput;
